import React from 'react';

interface ToggleProps {
  on: boolean;
  disabled?: boolean;
  onToggle: (on: boolean) => void;
  title?: string;
  size?: 'small' | 'medium';
}

export default function Toggle({
  on,
  disabled = false,
  onToggle,
  title = '',
  size = 'medium'
}: ToggleProps): JSX.Element {
  // Define size-based classes
  const sizeClasses = {
    small: {
      wrapper: 'h-5 w-8 min-w-8',
      knob: 'size-4',
      knobOn: 'left-[0.9rem]'
    },
    medium: {
      wrapper: 'h-6 w-11 min-w-11',
      knob: 'size-5',
      knobOn: 'left-[1.33rem]'
    }
  }[size];

  return (
    <button
      className={`${sizeClasses.wrapper} ${
        on && !disabled ? 'bg-black' : 'bg-slate-300'
      } relative rounded-full p-0.5 transition-all disabled:cursor-not-allowed disabled:bg-slate-200`}
      onClick={() => onToggle(!on)}
      data-testid="content-studio-toggle"
      disabled={disabled}
      role="checkbox"
      aria-checked={on}
      title={title}
    >
      <div
        className={`absolute top-0.5 ${sizeClasses.knob} rounded-full bg-white ${
          on ? sizeClasses.knobOn : 'left-0.5'
        } transition-all`}
      />
    </button>
  );
}
